import React, { useCallback, useContext } from 'react';

import { DragDropContext } from 'react-beautiful-dnd';

import { PacksDispatchContext } from './ApiProvider';
import AssignPacks from './packsToVenues/AssignPacks';
import VenueCalendar from './packsToVenues/VenueCalendar';
import VenueDetails from './packsToVenues/VenueDetails';

export default function PacksToVenues({ packs }) {
    const apiCall = useContext(PacksDispatchContext);
    const onDragStart = useCallback((result) => {}, []);

    const onDragEnd = useCallback((result) => {
        if (!result.destination || result.destination.droppableId !== 'venue-packs') return;
        const params = JSON.parse(result.draggableId);
        apiCall('form', {
            type: 'packToVenue',
            packId: params.packId,
            venueId: params.selectedVenue.id,
            filterDay: params.filterDay,
            filterDays: params.filterDays,
            formattedDate: params.formattedDate,
            formattedDates: params.formattedDates,
            selectedSchedules: params.selectedSchedules,
        });
    }, []);

    return (
        <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
            <div className="packs-to-venues-content tw-h-full tw-grid tw-grid-cols-3 tw-gap-4 tw-divide-x-2 tw-divide-gray-200">
                <div className="tw-min-h-0 tw-col-span-1">
                    <div className="tw-flex tw-flex-col tw-h-full tw-space-y-2 tw-overflow-auto">
                        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-sticky tw-top-0 tw-z-10">
                            <div className="tw-p-2.5 tw-flex tw-gap-2 tw-items-center tw-text-sm tw-font-semibold tw-text-charcoal">
                                <div className="tw-basis-full tw-shrink tw-grow">
                                    <div>{$t('Pack Name')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-grow">
                                    <div>{$t('Cost Per Pack')}</div>
                                </div>
                                <div className="tw-basis-9 tw-shrink-0"></div>
                            </div>
                        </div>
                        <AssignPacks packs={packs} />
                    </div>
                </div>
                <div className="tw-min-h-0 tw-col-span-2 tw-pl-4 tw-overflow-auto">
                    <div className="tw-space-y-2">
                        <VenueCalendar />
                        <VenueDetails />
                    </div>
                </div>
            </div>
        </DragDropContext>
    );
}
